class MotoHelmetPromo extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.activeSlot = 0;
    this.selections = [null, null];
    this.images = JSON.parse(this.querySelector('[data-promo-images]').textContent);
    this.grid = this.querySelector('[data-promo-grid]');
    this.slots = this.querySelector('[data-promo-slots]');
    this.status = this.querySelector('[data-promo-status]');
    this.review = this.querySelector('[data-promo-review]');
    this.dialog = this.querySelector('[data-promo-dialog]');
    try {
      const response = await fetch(this.dataset.catalog);
      if (!response.ok) throw new Error('Catalog unavailable');
      this.catalog = await response.json();
      this.models = new Map(this.catalog.models.map(model => [model.id, model]));
      this.pairs = { ready: false, pairs: {} };
      if (this.dataset.pairs) {
        const pairsResponse = await fetch(this.dataset.pairs);
        if (pairsResponse.ok) this.pairs = await pairsResponse.json();
      }
      const ready = this.catalog.checkoutReady && this.pairs.ready;
      this.purchaseReady = ready;
      this.review.textContent = ready ? 'Agregar mis dos cascos al carrito' : 'Revisar mi combinación';
      this.querySelectorAll('[data-promo-preview]').forEach(node => { node.hidden = ready; });
      this.querySelector('[data-promo-buy]').hidden = !ready;
      this.renderCards();
      this.renderSelection();
      this.querySelector('[data-promo-search]').addEventListener('input', () => this.filterCards());
      this.querySelector('select[data-promo-size]').addEventListener('change', () => this.filterCards());
      this.grid.addEventListener('click', event => {
        const button = event.target.closest('[data-promo-model]');
        if (!button || !this.grid.contains(button)) return;
        this.select(button.dataset.promoModel, button.dataset.promoSize);
      });
      this.slots.addEventListener('click', event => {
        const button = event.target.closest('[data-promo-slot]');
        if (!button) return;
        this.activeSlot = Number(button.dataset.promoSlot);
        this.renderSelection();
      });
      this.review.addEventListener('click', () => this.purchaseReady ? this.buyPair() : this.showReview());
      this.querySelector('[data-promo-buy]').addEventListener('click', () => this.buyPair());
      this.querySelectorAll('[data-promo-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      const requested = new URLSearchParams(location.search);
      const requestedModel = requested.get('modelo');
      const requestedSize = requested.get('talla');
      if (this.models.get(requestedModel)?.sizes.includes(requestedSize)) this.select(requestedModel, requestedSize);
      this.filterCards();
    } catch (error) {
      this.querySelector('[data-promo-count]').textContent = 'No pudimos cargar los modelos. Vuelve a cargar esta página.';
      this.status.textContent = 'No pudimos cargar la selección. Vuelve a cargar esta página para intentarlo de nuevo.';
    }
  }

  node(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  renderCards() {
    const fragment = document.createDocumentFragment();
    for (const model of this.models.values()) {
      const card = this.node('article', 'helmet-promo__card');
      card.dataset.model = model.id;
      const image = this.node('img', 'helmet-promo__image');
      image.src = this.images[model.id];
      image.alt = model.title;
      image.width = 400;
      image.height = 400;
      image.loading = 'lazy';
      const body = this.node('div', 'helmet-promo__card-body');
      body.append(this.node('p', 'helmet-promo__brand', model.brand), this.node('h3', '', model.title));
      body.append(window.MotoPromoPrices.render(model, this.catalog));
      const sizes = this.node('div', 'helmet-promo__sizes');
      for (const size of model.sizes) {
        const button = this.node('button', 'helmet-promo__size', size);
        button.type = 'button';
        button.dataset.promoModel = model.id;
        button.dataset.promoSize = size;
        button.setAttribute('aria-label', `Elegir ${model.title}, talla ${size}`);
        button.setAttribute('aria-pressed', 'false');
        sizes.append(button);
      }
      body.append(sizes);
      card.append(image, body);
      fragment.append(card);
    }
    this.grid.replaceChildren(fragment);
  }

  select(id, size) {
    const model = this.models.get(id);
    if (!model?.sizes.includes(size)) return;
    this.selections[this.activeSlot] = { modelId: id, size };
    if (!this.selections[1 - this.activeSlot]) this.activeSlot = 1 - this.activeSlot;
    this.renderSelection();
  }

  renderSelection() {
    this.slots.replaceChildren(...this.selections.map((selection, index) => {
      const button = this.node('button', 'helmet-promo__slot');
      button.type = 'button';
      button.dataset.promoSlot = index;
      button.setAttribute('aria-pressed', String(index === this.activeSlot));
      button.append(this.node('strong', '', `Casco ${index + 1}`));
      if (selection) {
        button.append(this.node('span', '', this.models.get(selection.modelId).title), this.node('small', '', `Talla ${selection.size} · Cambiar`));
      } else button.append(this.node('span', '', 'Elige modelo y talla'));
      return button;
    }));
    const complete = this.selections.every(Boolean);
    this.review.disabled = !complete || this.isAdding;
    this.status.textContent = complete ? 'Tu par está completo. Puedes cambiar cualquiera de los dos cascos.' : `Elige el modelo y la talla de tu ${this.activeSlot === 0 ? 'primer' : 'segundo'} casco.`;
    this.grid.querySelectorAll('[data-promo-model]').forEach(button => {
      const current = this.selections[this.activeSlot];
      button.setAttribute('aria-pressed', String(current?.modelId === button.dataset.promoModel && current?.size === button.dataset.promoSize));
    });
    this.filterCards();
  }

  filterCards() {
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const query = normalize(this.querySelector('[data-promo-search]').value.trim());
    const size = this.querySelector('select[data-promo-size]').value;
    let count = 0;
    for (const card of this.grid.children) {
      const model = this.models.get(card.dataset.model);
      card.hidden = !normalize(model.title + ' ' + model.brand).includes(query) || (size && !model.sizes.includes(size));
      if (!card.hidden) count++;
    }
    this.querySelector('[data-promo-count]').textContent = count ? `${count} modelos · Pulsa una talla para elegir el casco ${this.activeSlot + 1}` : 'No hay modelos con esa búsqueda y talla. Prueba otra opción.';
  }

  showReview() {
    if (!this.selections.every(selection => selection && this.models.get(selection.modelId)?.sizes.includes(selection.size))) return;
    const items = this.querySelector('[data-promo-review-items]');
    items.replaceChildren(...this.selections.map((selection, index) => {
      const item = this.node('article');
      item.append(this.node('strong', '', `Casco ${index + 1}: ${this.models.get(selection.modelId).title}`), this.node('p', '', `Talla ${selection.size}`));
      return item;
    }));
    this.dialog.showModal();
  }

  async buyPair() {
    const keys = this.selections.map(selection => selection && `${selection.modelId}:${selection.size}`);
    if (this.isAdding || !this.catalog.checkoutReady || !this.pairs.ready || keys.some(key => !key)) return;
    const variantId = this.pairs.pairs[keys.join('|')] || this.pairs.pairs[[...keys].reverse().join('|')];
    if (!variantId || !this.selections.every(selection => this.models.get(selection.modelId)?.sizes.includes(selection.size))) return;
    this.isAdding = true;
    const buttons = [this.review, this.querySelector('[data-promo-buy]')];
    buttons.forEach(button => { button.disabled = true; });
    this.status.textContent = 'Agregando tu par…';
    this.querySelector('[data-promo-purchase-status]').textContent = 'Agregando tu par…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const properties = Object.fromEntries(this.selections.map((selection, index) => [`Casco ${index + 1}`, `${this.models.get(selection.modelId).title} · Talla ${selection.size}`]));
      properties._moto_promo = '2x2199';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }) });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'No se pudo agregar el paquete. Revisa la disponibilidad y vuelve a intentarlo.');
      window.location.assign(`${root}cart`);
    } catch (error) {
      this.status.textContent = error.message;
      this.querySelector('[data-promo-purchase-status]').textContent = error.message;
      this.isAdding = false;
      buttons.forEach(button => { button.disabled = false; });
    }
  }
}
if (!customElements.get('moto-helmet-promo')) customElements.define('moto-helmet-promo', MotoHelmetPromo);
